import { IconButton, Typography, withStyles } from "@material-ui/core";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import Button from "../../components/Button";
import CloseIcon from "@material-ui/icons/Close";
import { useState, useCallback, useRef } from "react";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import Form from "./ModalForm";
import "../../styles/containers/Order.scss";
const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(-2),
    top: theme.spacing(-2),
    backgroundColor: "#ededed",
    height: "30px",
    width: "30px",
    zIndex: "1",
  },
});

function CropContainer({
  handleRetake,
  openForm,
  imgRef,
  onLoad,
  upImg,
  mainImage,
  handleClose,
}) {
  const previewCanvasRef = useRef(null);
  const [crop, setCrop] = useState({ unit: "%", width: 30, height: 30 });
  const [imageCode, setImageCode] = useState(null);
  const [nameOfImage, setNameOfImage] = useState("");
  const handleCompletedCrop = async (completedCrop) => {
    if (!completedCrop || !previewCanvasRef.current || !imgRef.current) {
      return;
    }
    const image = imgRef.current;
    const canvas = previewCanvasRef.current;
    const crop = completedCrop;
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    const ctx = canvas.getContext("2d");
    const pixelRatio = window.devicePixelRatio;
    canvas.width = crop.width * pixelRatio;
    canvas.height = crop.height * pixelRatio;
    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = "high";
    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    let dataUrl = await canvas?.toDataURL("image/jpeg");
    function dataURLtoFile(dataurl, filename) {
      var arr = dataurl.length ? dataurl.split(",") : [],
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    }
    function makeid(length) {
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    }
    let newString = makeid(20);
    let fileName = mainImage.name.substr(0, mainImage.name.lastIndexOf("."));
    let fileLength = mainImage.name.length - 1;
    let extensionName = mainImage.name.substr(
      mainImage.name.lastIndexOf("."),
      fileLength
    );
    if (dataUrl !== "data:,") {
      let imageName = `${fileName}-${newString}${extensionName}`;
      let file = dataURLtoFile(dataUrl, imageName);
      setNameOfImage(imageName);
      setImageCode(file);
    }
  };
  return (
    <div className="croppingModal">
      {!openForm && (
        <>
          <Button
            className="modalButton retake"
            title={"Retake"}
            backgroundColor="#ededed"
            color="#383838"
            onClick={handleRetake}
            order={true}
          />

          <ReactCrop
            src={upImg}
            onImageLoaded={onLoad}
            crop={crop}
            imageStyle={{
              maxWidth: "100%",
              maxHeight: window.screen.width <= 1024 ? "310px" : "400px",
            }}
            ruleOfThirds
            minHeight="100"
            minWidth="100"
            onChange={(c) => setCrop(c)}
            onComplete={(c) => handleCompletedCrop(c)}
          />
        </>
      )}
      <Form
        previewCanvasRef={previewCanvasRef}
        crop={crop}
        display={!openForm ? "none" : "block"}
        handleRetake={handleRetake}
        imageCode={imageCode}
        imageName={nameOfImage}
        handleClose={handleClose}
      />
    </div>
  );
}

export default CropContainer;
